<div class="multi-select" [class.multi-select--disabled]="disabled">
  <div
    class="multi-select__header"
    role="button"
    tabindex="0"
    [attr.aria-expanded]="isOpen"
    [attr.aria-disabled]="disabled"
    (click)="toggleDropdown()"
    (keydown.enter)="toggleDropdown()"
  >
    @if (selectedItems.length) {
      @if (tagsMode) {
        <span class="multi-select__selected-items">
          @for (chip of selectedChips; track chip.value) {
            <span
              class="multi-select__tag"
              [class.multi-select__tag--warning]="chip.tagVariant === 'warning'"
            >
              @if (chip.color) {
                <span class="multi-select__tag-dot" [style.background-color]="chip.color"></span>
              }
              {{ chip.label }}
            </span>
          }
        </span>
      } @else {
        <span class="multi-select__selected-items">
          @if (selectedOptions.length === 1 && selectedOptions[0].color) {
            <span
              class="multi-select__dot"
              [style.background-color]="selectedOptions[0].color"
            ></span>
          }
          {{ selectedItems.join(', ') }}
        </span>
      }
    } @else if (!disabled) {
      <span class="multi-select__placeholder">{{
        placeholder || translateData['default_placeholder'] || 'Select...'
      }}</span>
    }
    @if (selectedItems.length && !disabled) {
      <span
        class="multi-select__clear"
        role="button"
        tabindex="0"
        [attr.aria-label]="translateData['clear_selection'] || 'Clear selection'"
        (click)="clearSelection($event)"
        (keydown.enter)="clearSelection($event)"
        >&times;</span
      >
    }
    <span class="multi-select__arrow"></span>
  </div>

  @if (isOpen) {
    <div class="multi-select__dropdown" [class.multi-select__dropdown--up]="opensUp">
      <input
        #searchInput
        class="multi-select__search"
        type="text"
        role="combobox"
        aria-autocomplete="list"
        [attr.aria-expanded]="isOpen"
        [attr.aria-activedescendant]="activeIndex >= 0 ? optionId(activeIndex) : null"
        [formControl]="searchControl"
        (keydown)="onSearchKeydown($event)"
        [placeholder]="
          searchPlaceholder || translateData['default_search_placeholder'] || 'Search...'
        "
        [disabled]="disabled"
        [attr.aria-label]="translateData['aria_search_options'] || 'Search options'"
      />

      @if (hasResults()) {
        <div
          class="multi-select__options"
          role="listbox"
          [style.max-height.px]="optionsMaxHeight"
          [attr.aria-multiselectable]="multiple"
        >
          @for (option of filteredOptions; track trackByValue($index, option); let i = $index) {
            <div
              class="multi-select__option"
              role="option"
              [id]="optionId(i)"
              [class.multi-select__option--selected]="isSelected(option)"
              [class.multi-select__option--active]="i === activeIndex"
              [class.multi-select__option--disabled]="isOptionDisabled(option)"
              [attr.aria-selected]="isSelected(option)"
              [attr.aria-disabled]="isOptionDisabled(option)"
              (mouseenter)="activeIndex = i"
              (click)="toggleSelection(option)"
            >
              @if (option.color) {
                <span class="multi-select__dot" [style.background-color]="option.color"></span>
              }
              {{ option.label }}
            </div>
          }
        </div>
      } @else {
        @if (searchTermMode() && searchTerm) {
          <div
            class="multi-select__add-option"
            role="button"
            tabindex="0"
            (click)="addSearchTerm()"
            (keydown.enter)="addSearchTerm()"
          >
            <span class="multi-select__add-option--icon">+</span>
            {{ translateData['add_value'] || 'Add' }} "{{ searchTerm }}"
          </div>
        } @else {
          <div class="multi-select__no-results">
            {{ noResultsText || translateData['default_no_results'] || 'No results found' }}
          </div>
        }
      }

      @if (actionLabel()) {
        <div
          class="multi-select__add-option"
          role="button"
          tabindex="0"
          (click)="onActionClick()"
          (keydown.enter)="onActionClick()"
        >
          <span class="multi-select__add-option--icon">+</span>
          {{ actionLabel() }}
        </div>
      }
    </div>
  }
</div>
